/**
 * Chrome shared by the square icon buttons that sit together in the app shell
 * (theme, refresh). One constant rather than a copy per button: they are always
 * rendered side by side, so any drift in height or border shows up immediately
 * as a mismatched pair.
 */
export const shellIconButtonClass =
  'inline-flex h-9 w-9 items-center justify-center rounded-md border border-line bg-paper text-ink-2 hover:bg-paper-2 transition-colors';
